import { LocationListTable } from "./LocationListTable";

export default LocationListTable;
